<template>
  <div v-if="showContent" :class="`refapp-video__content refapp-video__content--${alignment}`">
    <div>
      <div v-if="!isSlotEmpty" ref="slotWrapper">
        <slot></slot>
      </div>
      <template v-else>
        <component :is="`h${headingLevel}`" v-if="heading" class="refapp-video__content-heading">
          <span class="refapp-video__content-heading-content">
            {{ heading }}
          </span>
        </component>

        <p v-if="text" class="refapp-video__content-text">
          <span class="refapp-video__content-text-content">
            {{ text }}
          </span>
        </p>
      </template>
    </div>

    <a
      v-if="ctalink && ctatext"
      class="refapp-video__content-cta"
      :href="ctalink"
      target="_blank"
      data-refapp-tagging-target="cta"
    >
      {{ ctatext }}
    </a>
  </div>
</template>

<script>
export default {
  name: 'refapp-video-content',
  inject: ['heading', 'headingLevel', 'text', 'ctalink', 'ctatext', 'alignment'],
  data() {
    return {
      isSlotEmpty: false,
    };
  },
  computed: {
    showContent() {
      return !!(this.heading || this.ctalink || !this.isSlotEmpty);
    },
  },
  mounted() {
    this.checkSlotEmpty();
  },
  methods: {
    // Often content editors accidentally leave empty tags when they delete the rich text content.
    checkSlotEmpty() {
      if (!this.$slots.default || !this.$refs.slotWrapper) {
        this.isSlotEmpty = true;
        return;
      }
      this.isSlotEmpty = this.$refs.slotWrapper.textContent.trim() === '';
    },
  },
};
</script>
